import { configureAmplify as configureAmplifyBase } from "@mimber/auth"

let configured = false

/**
 * Configure AWS Amplify for mimber-organization with Cognito settings
 * Reads configuration from Vite environment variables
 */
export const configureAmplify = () => {
  if (configured) return

  const domain = import.meta.env.VITE_COGNITO_DOMAIN
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID
  const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID
  const redirectSignIn =
    import.meta.env.VITE_COGNITO_REDIRECT_URI ||
    `${window.location.origin}/authenticate`
  const redirectSignOut =
    import.meta.env.VITE_COGNITO_LOGOUT_URI || window.location.origin

  if (!domain || !userPoolId || !userPoolClientId) {
    console.error(
      "Cognito configuration missing: domain, user pool id, and client id are required"
    )
    return
  }

  // Parse scopes from environment variable (comma-separated)
  let scopes = ["openid", "email", "profile", "aws.cognito.signin.user.admin"]
  if (import.meta.env.VITE_COGNITO_SCOPES) {
    const envScopes = (import.meta.env.VITE_COGNITO_SCOPES as string)
      .split(",")
      .map((scope) => scope.trim())
      .filter(Boolean)
    if (envScopes.length > 0) {
      scopes = envScopes
    }
  }

  configureAmplifyBase({
    domain,
    userPoolId,
    userPoolClientId,
    redirectSignIn,
    redirectSignOut,
    scopes,
  })

  configured = true
}
